import React from 'react';
import OTPLogin from '../components/auth/OTPLogin';

const Login = () => {
  return <OTPLogin />;
};

export default Login;
